import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ComponentFactoryResolver,
  EventEmitter,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { TareaModel } from 'src/app/services/tareas.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Subject } from 'rxjs';
import { ComponentValueDirective } from '../../componentValue.directive';
import { TaskCaseService } from '../../services/taskCase.service';
import { TaskCase } from '../../interface/task.interface';
import { FilesService } from 'src/app/core/services/files.service';
import { TaskCaseFileService } from '../../services/task-case-file.service';
import { COMPONENTS } from '../../../../components/casos/ver-tarea/constants/components.constant';
import { UserService } from 'src/app/core/services/user.service';
import { CaseService } from '../../services/case.service';
import { CaseRecordService } from '../../services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';
import { ModalFileShowViewComponent } from 'src/app/components/shared/components/modal-file-show-view/modal-file-show-view.component';

enum status {
  initial = 'Sin comenzar',
  running = 'En ejecución',
  tobeApproved = 'Por aprobar',
  toFinalize = 'Por finalizar',
  archived = 'Archivado',
}
@Component({
  selector: 'app-see-task-case',
  templateUrl: './see-task-case.component.html',
  styleUrls: ['./see-task-case.component.scss'],
})
export class SeeTaskCaseComponent implements OnInit {
  user: string = sessionStorage.getItem('id_usuario');
  files: any[] = [];
  editar: boolean = false;
  textoGuardar = 'Guardar';
  idTareas: any = {};

  estafa: boolean = false;
  personalInterno: boolean = false;
  ingresosDescono: boolean = false;

  //
  correo;
  nombre;
  nm;
  //
  components = COMPONENTS;
  ComponentValue = null;
  componentRef: any;
  private timeOut: any;
  showAdjuntos = true;
  tareas: TareaModel[];

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild(ComponentValueDirective, { static: false })
  component!: ComponentValueDirective;
  emiteTareaGuardadaAlComponenteDinamico: Subject<void> = new Subject<void>();

  form: FormGroup = this.fb.group({
    observations: ['', [Validators.required, Validators.minLength(20)]], //new FormControl({ value: '' }),
    personalInternoInvolucrado: [''],
    ingresosDescono: [''],
    estafa: [''],
    lastUser: [sessionStorage.getItem('correo')],
  });

  permisosStr: string = null;
  correo_usuario: string = sessionStorage.getItem('correo');
  changeTitleTask: boolean;
  titleTaskChange: string;
  constructor(
    public dialogRef: MatDialogRef<SeeTaskCaseComponent>,
    @Inject(MAT_DIALOG_DATA) public task: TaskCase,
    public fb: FormBuilder,
    private componentFactoyResolver: ComponentFactoryResolver,
    public _snackbar: MatSnackBar,
    private readonly taskCaseService: TaskCaseService,
    private readonly filesService: FilesService,
    private readonly taskCaseFileService: TaskCaseFileService,
    private readonly userService: UserService,
    private readonly caseService: CaseService,
    private readonly caseRecordService: CaseRecordService,
    private readonly casesService: CasesService,
    private readonly dialog: MatDialog
  ) {
    this.getCaso();
  }
  async getCaso() {
    let caseId;

    if (typeof this.task.case == 'string') {
      caseId = this.task.case;
    } else if (typeof this.task.case == 'object') {
      caseId = this.task.case._id;
    }
    this.caseService.getCase(caseId).subscribe((response) => {
      this.case = response;
    });
  }
  case;
  get canEdit() {
    return (
      this.userService.permissions.editTaskCase ||
      this.userService.currentUser._id == this.case?.assigned?._id
    );
  }

  get stateCase() {
    return status[this.case?.status];
  }

  get canDelete() {
    return (
      this.userService.permissions.deleteTaskCase ||
      this.userService.currentUser._id == this.case?.assigned?._id
    );
  }
  get canUpdate() {
    return this.form.valid;
  }

  async ngOnInit() {
    this.requireObservation();
    this.getTaskCaseFiles();
    this.form.controls.observations.setValue(this.task.observations);
    const findIndex = this.components.findIndex(
      (component) => component.value === this.task.component
    );

    if (findIndex !== -1) {
      this.ComponentValue = this.components[findIndex];
      this.timeOut = setTimeout(() => {
        const componentFactoy =
          this.componentFactoyResolver.resolveComponentFactory<{ data: any }>(
            this.ComponentValue.component
          );

        const viewContainerRef = this.component.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent<{ data: any }>(
          componentFactoy
        );
        this.componentRef.instance.data = {
          task: JSON.parse(JSON.stringify(this.task)),
          personType: ' this.caso.personType',
        };
        this.componentRef.instance.saveEvent$ =
          this.emiteTareaGuardadaAlComponenteDinamico.asObservable();
      }, 10);
    }
  }
  view(file) {
        this.dialog
          .open(ModalFileShowViewComponent, {
            data: file,
            minWidth: '1%',
          })
          .afterClosed()
          .subscribe(async (re) => {});
  }
  requireObservation() {
    if (!this.task.requiresObservations) {
      this.form.controls.observations.disable();
    }
  }
  getTaskCaseFiles() {
    this.taskCaseFileService.getAllTaskFile(this.task._id).subscribe((res) => {
      this.files = res;
    });
  }
  addFile() {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          const newFile = {
            url,
            name: file.name,
            task: this.task._id,
          };
          this.taskCaseFileService
            .createTaskFile(newFile)
            .subscribe((file: any) => {
              this.files.push(file);
            });
        },
      });
    };
  }
  async deleteFile(id: any) {
    this.taskCaseFileService.deleteTaskFile(id).subscribe(() => {
      this.getTaskCaseFiles();
    });
  }
  async downloadFile(file) {
    // window.open(`${url}`, '_blank');
    const path = file.url + `?name=${file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  async deleteTask() {
    this.loading = true;
    this.taskCaseService
      .deleteTaskCase(this.task._id)
      .subscribe((taskDeleted: any) => {
        this.loading = false;
        this.dialogRef.close({ action: 'deleted' });
      });
  }

  async editarToggle() {
    if (this.editar) this.form.controls.observations.enable();
    if (this.editar) this.form.controls.personalInternoInvolucrado.enable();
    if (this.editar) this.form.controls.estafa.enable();
    else {
      this.form.controls.observations.disable();
      this.form.controls.personalInternoInvolucrado.disable();
      this.form.controls.estafa.disable();
    }
    this.form.value.files = this.files;
  }

  public loading: boolean = false;
  async guardar() {
    if (this.componentRef) {
      const { form } = this.componentRef.instance;
      if (form) {
        const { value, invalid } = form;
        if (invalid) {
          this._snackbar.open(
            'Error: Debe completar los campos requeridos (*)',
            '❌'
          );
          return;
        }
        this.form.value.data = value;
      }
    }
    if (this.componentRef) {
      if (
        this.componentRef.instance.data.task.component.toString() !=
          'RegistrarRelacionMontosSalvados' &&
        this.componentRef.instance.data.task.component.toString() !=
          'RastreoMovimientosBancarios' &&
        this.componentRef.instance.data.task.component.toString() !=
          'InteraccionRedesSociales' &&
        this.componentRef.instance.data.task.component.toString() !=
          'CuentasOtrosBancos' &&
        this.componentRef.instance.data.task.component.toString() !=
          'DatosMigratorios' &&
        this.componentRef.instance.data.task.component.toString() !=
          'ElevaAdministraciónSeguros' &&
        this.componentRef.instance.data.task.component.toString() !=
          'CasoRoboHurto' &&
        this.componentRef.instance.data.task.component.toString() !=
          'ValidacionDeDocumentos'
      ) {
        this.loading = true;

        await this.taskCaseService
          .updateTaskCase(this.task._id, {
            observations: this.form.value.observations,
            data: this.form.value.data,
            updateBy: this.userService.currentUser._id,
          })
          .subscribe((dataUpdated) => {
            this.caseRecordService.updatedRecord.next(true);
            this.dialogRef.close({ action: 'updated', task: dataUpdated });
            this.loading = false;
          });
      } else if (
        this.componentRef.instance.data.task.component.toString() ==
        'ValidacionDeDocumentos'
      ) {
        await this.taskCaseService
          .getTaskCase(this.task._id)
          .subscribe(async (res: any) => {
            if (res.data) {
              this.form.value.data.documentos = res.data.documentos;
            }
            await this.taskCaseService
              .updateTaskCase(this.task._id, {
                observations: this.form.value.observations,
                data: this.form.value.data,
                updateBy: this.userService.currentUser._id,
              })
              .subscribe((dataUpdated) => {
                this.caseRecordService.updatedRecord.next(true);
                this.dialogRef.close({ action: 'updated', task: dataUpdated });
                this.loading = false;
              });
          });
      } else {
        console.log('else');

        await this.taskCaseService
          .getTaskCase(this.task._id)
          .subscribe((res) => {
            this.caseRecordService.updatedRecord.next(true);
            this.dialogRef.close({
              action: 'updated',
              task: res,
            });
          });
      }
    } else {
      this.loading = true;
      await this.taskCaseService
        .updateTaskCase(this.task._id, {
          observations: this.form.value.observations,
          data: this.form.value.data,
          updateBy: this.userService.currentUser._id,
        })
        .subscribe((dataUpdated) => {
          this.caseRecordService.updatedRecord.next(true);
          this.dialogRef.close({ action: 'updated', task: dataUpdated });
          this.loading = false;
        });
    }
    // this.loading = true;
    // await this.taskCaseService
    //   .updateTaskCase(this.task._id, {
    //     observations: this.form.value.observations,
    //     data: this.form.value.data,
    //     updateBy: this.userService.currentUser._id,
    //   })
    //   .subscribe((dataUpdated) => {
    //     this.caseRecordService.updatedRecord.next(true);
    //     this.dialogRef.close({ action: 'updated', task: dataUpdated });
    //     this.loading = false;
    //   });

    this.form.value.files = this.files;
    this.emiteTareaGuardadaAlComponenteDinamico.next();
  }

  async saveNewTitle() {
    await this.taskCaseService
      .updateTaskCase(this.task._id, {
        editedTitle: this.titleTaskChange,
      })
      .subscribe((dataUpdated: any) => {
        this.caseRecordService.updatedRecord.next(true);
        this.loading = false;
        this.task = dataUpdated;
        dataUpdated['task'] = this.task;
        this.changeTitleTask = false;
        this.taskCaseService.taskUpdated.next(dataUpdated);
      });
  }
  ipdateCase(aditionalInformation, ci) {
    aditionalInformation.numero_de_identificacion = ci;
    aditionalInformation.tipo_de_persona = ci[0].toUpperCase();
    this.casesService
      .update(this.case._id, {
        additionalInformation: aditionalInformation,
      })
      .subscribe((res: any) => {
        this.caseService.updateCaseTaskRAs.next(res);
      });
  }
}
